import {Users} from 'lucide-react';
import type {RouteObject} from 'react-router-dom';

import type {MenuItemElement} from '@/components/menu/Menu';
import i18n from '@/i18n';
import {protectedLoader} from '@/utils/protectedLoader';

export const routes = [
  {
    path: 'users',
    children: [
      {
        path: '',
        loader: protectedLoader('USERS', 'VIEW_USERS'),
        async lazy() {
          const {UserListPage} = await import('./pages/UserListPage');
          return {element: <UserListPage />};
        },
        children: [
          {
            path: 'add',
            async lazy() {
              const {AddUserPage} = await import('./pages/AddUserPage');
              return {
                element: <AddUserPage />,
              };
            },
          },
          {
            path: ':userName',
            loader: protectedLoader('USERS', 'VIEW_USERS'),
            async lazy() {
              const {EditUserPage} = await import('./pages/EditUserPage');
              return {
                element: <EditUserPage />,
              };
            },
          },
        ],
      },
    ],
  },
] as RouteObject[];

export const menuItems = [
  {
    path: '/users',
    text: i18n.t('Users'),
    icon: <Users />,
    permission: 'VIEW_USERS',
    entitlement: 'USERS',
  },
] as MenuItemElement[];
